import Login from '../components/authentication/Index.vue';
import CustomerSetup from '../components/customer-setup/Index.vue';
import Network from '@/components/network/Index.vue';
import Home from '../components/home/Index.vue';
import Dashboard from '../components/dashboard/Index.vue';
import LandingSection from '../components/dashboard/sections/landing/LandingSection';
import FulfillmentSection from '../components/dashboard/sections/fulfillment/FulfillmentSection.vue';
import ConversionSection from '../components/dashboard/sections/conversion/ConversionSection.vue';
import Roles from '../components/roles/Index.vue';
import Regions from '../components/regions/Index.vue';
import Reps from '../components/users/reps/Index.vue';
import Customers from '../components/users/customers/Index.vue';
import Specific from '../components/users/specific/Index.vue';
import Public from '../components/users/public/Index.vue';
import VendorUsers from '../components/users/vendors/Index.vue';
import Privileges from '../components/privileges/Index.vue';
import QuoteStatus from '../components/reports/status/Index.vue';
import RfcStatus from '../components/reports/rfcstatus/Index.vue';
import SpecStatus from '../components/reports/specstatus/Index.vue';
import ProjectStatus from '../components/projects/status/Index.vue';
import Reports from '../components/reports/Index.vue';
import SalesOrderReports from '../components/reports/sales-order-reports/Index.vue';
import Specs from '@/components/reports/specs/Index.vue';
import QuoteReports from '../components/reports/quotes/Index.vue';
import QuoteReportsLite from '../components/reports/quotes-lite/Index.vue';
import DiscountReports from '../components/reports/discount-request/Index.vue';
import TenderReports from '../components/reports/tender/Index.vue';
import ProductSalesReports from '../components/reports/product-sales-reports/Index.vue';
import PriceLists from '../components/pricelists/Index.vue';
import Projects from '../components/projects/Index.vue';
import RfcReports from '@/components/reports/rfc/Index.vue';
import Factories from '@/components/transport/factories/Index.vue';
import Packages from '@/components/transport/packages/Index.vue';
import Vehicles from '@/components/transport/vehicles/Index.vue';
import ProductConfig from '@/components/transport/product-config/Index.vue';
import CostMatrix from '@/components/transport/cost-matrix/Index.vue';
import Vendors from '@/components/vendors/Index.vue';
import VendorAssign from '@/components/vendors/assign/Index.vue';
import Departments from '@/components/departments/Index.vue';
import InstallationCosts from '@/components/installation_cost/Index.vue';
import Notifications from '@/components/notifications/Index.vue';
import Survey from '@/components/survey/Index.vue';
import Tokens from '@/components/tokens/Index.vue';
import Branches from '@/components/branches/Index.vue';
import Processes from '@/components/process/Index.vue';
import Stock from '@/components/stock/Index.vue';
import EscalationSection from "../components/dashboard/sections/escalation/EscalationSection";
import ConversionSectionPy from "../components/dashboard/sections/conversionPy/ConversionSection.vue";
import QuoteContent from "../components/reports/quote-content/Index.vue";

export const routes = [
	{
		path: '/',
		component: Home,
	},
  {
    path: '/dashboard',
    component: Dashboard,
    children: [
      {
        path: '/dashboard/landing',
        component: LandingSection
      },
      {
        path: '/dashboard/conversion',
        component: ConversionSection,
      },
      {
        path: '/dashboard/fulfillment',
        component: FulfillmentSection,
      },
      {
        path: '/dashboard/escalation',
        component: EscalationSection,
      },
      {
        path: '/dashboard/conversion-py',
        component: ConversionSectionPy,
      }
    ]
  },
	{
		path: '/network',
		component: Network
	},
	{
		path: '/login',
		component: Login
	},
  {
    path: '/customer-setup',
    component: CustomerSetup
  },
	{
		path: '/pricelists',
		component: PriceLists
	},
	{
		path: '/regions',
		component: Regions
	},
	{
		path: '/vendors',
		component: Vendors
	},
	{
		path: '/vendor-assign',
		component: VendorAssign
	},
	{
		path: '/departments',
		component: Departments
	},
	{
		path: '/roles',
		component: Roles
	},
	{
		path: '/reports/product-sales-reports',
		component: ProductSalesReports,
	},
	{
		path: '/reports/sales-order-reports',
		component: SalesOrderReports,
	},
	{
		path: '/reports/quote-reports',
		component: QuoteReports,
	},
  {
    path: '/reports/quote-reports-lite',
    component: QuoteReportsLite,
  },
	{
		path: '/reports/tender-reports',
		component: TenderReports,
	},
	{
		path: '/reports/rfc-reports',
		component: RfcReports,
	},
	{
		path: '/reports/spec-reports',
		component: Specs,
	},
	{
		path: '/reports/discount-request-reports',
		component: DiscountReports,
	},
	{
		path: '/users',
		component: Reps,
		children: [
			/*{
				path: 'reps',
				component: Reps,
			},
			{
				path: 'customers',
				component: Customers,
			},
			{
				path: 'specific',
				component: Specific,
			},
			{
				path: 'public',
				component: Public,
			}*/
		]
	},
	{
		path: '/reports',
		component: Reports,
		children: [
			/*{
				path: '/reports/quote-single-content',
				component: QuoteContent,
			}*/
			/*{
				path: 'tender-reports',
				component: TenderReports,
			},*/
			/*{
				path: 'product-sales-reports',
				component: ProductSalesReports,
			},*/
            /*{
                path: 'rfc-reports',
                component: RfcReports,
            },
            {
                path: 'discount-request-reports',
                component: DiscountReports,
            }*/
		]
	},
	{
		path: '/users/reps',
		component: Reps,
	},
	{
		path: '/users/customer-users',
		component: Customers,
	},
	{
		path: '/users/specific-users',
		component: Specific,
	},
	{
		path: '/users/public-users',
		component: Public,
	},
	{
		path: '/users/vendor-users',
		component: VendorUsers,
	},
	{
		path: '/privileges',
		component: Privileges
	},
	{
		path: '/quote-status',
		component: QuoteStatus
	},
    {
        path: '/rfc-status',
        component: RfcStatus
	},
	{
		path: '/spec-status',
		component: SpecStatus
	},
    {
        path: '/project-status',
        component: ProjectStatus
    },
    {
        path: '/projects',
        component: Projects
	},
	{
		path: '/transport/factories',
		component: Factories
	},
    {
		path: '/transport/packages',
		component: Packages
	},
	{
		path: '/transport/vehicles',
		component: Vehicles
	},
	{
		path: '/transport/product-configuration',
		component: ProductConfig
	},
	{
		path: '/transport/cost-matrix',
		component: CostMatrix
	},
	{
		path: '/installation-costs',
		component: InstallationCosts
	},
	{
		path: '/notifications',
		component: Notifications
	},
	{
		path: '/survey',
		component: Survey
	},
  {
    path: '/tokens',
    component: Tokens
  },
  {
    path: '/branches',
    component: Branches
  },
  {
    path: '/processes',
    component: Processes
  },
  {
    path: '/stock-levels',
    component: Stock
  },
  {
    path: '/quote-single-content',
    component: QuoteContent
  }
]
